export default {
    HIOPOSWEBSERVICES: 'https://hiopos-dev.saas.com.co',
    HIOPOSREPORTS: 'https://hioposreports-dev-staging.saas.com.co',
  }
  